import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../class/status';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})

export class SettingComponent implements OnInit {
  menulist:menulist = [
    // {id:'1',name:'鑽石收益設定'},
    // {id:'2',name:'鑽石消耗設定'},
    {id:'3',name:'一句話設定'}
  ];

  status_option:menulist;

  table_column_list:string[][]=[
    [],
    ['描述','類型','點數','儲值台幣','狀態','操作'],
    ['描述','類型','點數','匯率','狀態','操作'],
    ['標題','描述','數值','狀態','操作']

  ];

  pageobj:page = {page:0,count:10,total_count:0};
  now:string='3';
  edit_data:any=[];
  data:any=[];
  loading:boolean=false;
  preurl :string = '';
  tmp_img_b64:{};
 
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }
  content:string = 'accuse';
  ngOnInit(): void {
    this.init_list();
  }

  add_new(){
    this.loading = true; 
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now};
    this.httpClient.post<any>("/add_setting.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
          this.init_list();
      }
      console.log('res',res);
    });
  }

  init_list(){
    this.loading = true; 
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now};
    this.httpClient.post<any>("/get_setting_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
        this.status_option = res.options_list
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        this.status_option = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
    });
  }

  upload(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.tmp_img_b64 = e.target.result;
      });
    }
  }

  save(){
      let tmppic = Object.keys(this.tmp_img_b64).length>0 ? this.tmp_img_b64:false; 
      const body = {data:this.edit_data,new_img:tmppic,type:this.now};
      this.loading = true;
      this.httpClient.post<any>("/update_setting.php",body).subscribe(res => {
        this.loading = false;
        this.init_list();
        console.log('res',res);
      });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }
}
